import AsyncComponentLoading from 'messaging-publishing-lib/components/AsyncComponentLoading';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyStateWithTemplatesAsync = Loadable({
  loader: () => import( /* webpackChunkName: "onboarding-empty-state-with-templates" */'./EmptyStateWithTemplates'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "onboarding-empty-state-with-templates"
  }, props)),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "onboarding-empty-state-with-templates"
  }, props, {
    navMarkerErrorName: "ONBOARDING_EMPTY_STATE_LOAD_FAILED"
  }))
});
export default EmptyStateWithTemplatesAsync;